/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Render the `main` element consistently in IE.
 */
main {
  display: block;
}

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

/*Warning*/
:host(.gxg-validation--warning) .form-element {
  border-color: var(--color-warning-dark);
}
:host(.gxg-validation--warning) .form-element:focus {
  outline-color: var(--color-warning-dark);
  border-color: var(--color-warning-dark);
}
:host(.gxg-validation--warning) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-warning-dark);
}

/*Error*/
:host(.gxg-validation--error) .form-element {
  border-color: var(--color-error-dark);
}
:host(.gxg-validation--error) .form-element:focus {
  outline-color: var(--color-error-dark);
  border-color: var(--color-error-dark);
}
:host(.gxg-validation--error) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-error-dark);
}

/*Success*/
:host(.gxg-validation--success) .form-element {
  border-color: var(--color-success-dark);
}
:host(.gxg-validation--success) .form-element:focus {
  outline-color: var(--color-success-dark);
  border-color: var(--color-success-dark);
}
:host(.gxg-validation--success) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-success-dark);
}

/*Tooltip*/
.tooltip-outer-wrapper {
  display: grid;
  grid-template-columns: 0fr;
  transition: grid-template-columns var(--timing-02);
}

:host(.tooltip--visible) .tooltip-outer-wrapper {
  grid-template-columns: 1fr;
}

.tooltip-inner-wrapper {
  overflow: hidden;
  transition: 150ms width;
  width: 0;
}
.tooltip-inner-wrapper gxg-icon {
  display: flex;
  position: relative !important;
  top: 0 !important;
  transform: none !important;
  margin-inline-start: var(--spacing-comp-01);
}
.tooltip-inner-wrapper--visible {
  width: 24px;
}
.tooltip-inner-wrapper--hidden {
  display: none;
}

:host(.gxg--disabled) .form-element,
:host(.gxg--disabled.form-element) {
  pointer-events: none;
  background-color: var(--gxg-background-color--disabled) !important;
  color: var(--gxg-color--disabled) !important;
  border-color: var(--gxg-border-color--disabled) !important;
  cursor: default !important;
}

:host {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/*****************************************************
FORM ELEMENT WRAPPER
*****************************************************/
:host .outer-wrapper {
  position: relative;
  width: 100%;
}
:host .inner-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
}
:host .inner-wrapper gxg-icon {
  position: absolute;
}

/*****************************************************
TOOLTIP
*****************************************************/
:host(.tooltip) .inner-wrapper {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
:host(.tooltip) .tooltip-container {
  width: 0;
  overflow: hidden;
  transition: width --timing-01;
}

:host(.tooltip--visible) .tooltip-container {
  width: 20px;
}

/*****************************************************
LABEL
*****************************************************/
:host label {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  display: flex;
  align-items: center;
  cursor: default;
}
:host label .required {
  padding-inline-start: 2px;
}
:host input {
  position: relative;
  width: 100%;
}

/*label position*/
:host([label-position=start]) .outer-wrapper {
  display: flex;
  flex-direction: row;
}

/*****************************************************
TEXT
*****************************************************/
:host input[type=text],
:host input[type=password] {
  border-width: var(--border-width-sm);
  border-color: var(--gray-02);
  border-style: var(--border-style-regular);
  border-radius: var(--border-radius-sm);
  padding-left: var(--spacing-comp-01);
  padding-right: var(--spacing-comp-01);
  color: var(--color-on-background);
  background-color: var(--color-background);
  height: var(--gxg-form-text-height);
  box-sizing: border-box;
}
:host input[type=text]:focus,
:host input[type=password]:focus {
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
:host input[disabled] {
  background-color: var(--gray-01);
  color: var(--color-on-disabled);
}
:host input[disabled]::-webkit-input-placeholder {
  color: var(--gray-04);
}
:host .input--borderless {
  border-color: transparent !important;
}
:host input[readonly] {
  cursor: default;
}

:host([minimal]) input[type=text]:not(:focus),
:host([minimal]) input[type=password]:not(:focus) {
  border-color: transparent;
  background-color: transparent;
}
:host([minimal]) input.cursor-inside {
  border-color: var(--gray-02) !important;
  background-color: var(--color-background);
}
:host([minimal]) input[type=text]:focus,
:host([minimal]) input[type=password]:focus {
  border-color: transparent;
}

:host([minimal]:not([icon-position=start])) input[type=text],
:host([minimal]:not([icon-position=start])) input[type=password] {
  padding-inline-start: 0;
}
:host([minimal]:not([icon-position=start])) input.cursor-inside {
  padding-inline-start: var(--spacing-comp-01);
}
:host([minimal]:not([icon-position=start])) input[type=text]:focus,
:host([minimal]:not([icon-position=start])) input[type=password]:focus {
  padding-inline-start: var(--spacing-comp-01);
}

:host([minimal][over-dark-background]) input[type=text]:not(:focus),
:host([minimal][over-dark-background]) input[type=password]:not(:focus) {
  color: var(--color-on-primary);
}

/*****************************************************
INPUT TEXT ICON
*****************************************************/
:host gxg-icon {
  top: 50%;
  transform: translateY(-50%);
}

:host([icon-position=end]) .clear-button gxg-icon:not(.clear-button) {
  right: 16px;
}

:host(.has-icon[icon-position=start]) input {
  padding-inline-start: 20px;
}

:host([icon-position=end]) input {
  padding-inline-end: 20px;
}

:host([icon-position=end]) .inner-wrapper {
  flex-direction: row-reverse;
}

/*****************************************************
CLEAR BUTTON
*****************************************************/
:host gxg-icon.clear-button {
  left: auto;
  opacity: 0.5;
  cursor: pointer;
}
:host gxg-icon.clear-button:hover {
  opacity: 1;
}

:host([clear-button][icon-position=end]) gxg-icon:not(.clear-button) {
  right: 16px;
}
:host([clear-button][icon-position=end]) input {
  padding-inline-end: 36px;
}

/*****************************************************
CUSTOM ICON
*****************************************************/
.custom-icon:has(+ .clear-button) {
  /* Styles for the target element if the next sibling has the class */
}

/*****************************************************
VALIDATION
*****************************************************/
.messages-wrapper {
  margin-top: var(--spacing-comp-02);
  display: flex;
  gap: var(--spacing-comp-01);
  flex-direction: column;
}

/*****************************************************
STYLE
*****************************************************/
:host([text-style=regular]) input {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

:host([text-style=quote]) input {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

:host([text-style=title-01]) input {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

:host([text-style=title-02]) input {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

:host([text-style=title-03]) input {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

:host([text-style=title-04]) input {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

:host([text-style=title-05]) input {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

/*****************************************************
INPUT TYPE FILE
*****************************************************/
:host(.file) .form-element--readonly {
  user-select: none;
  cursor: pointer;
}

/*****************************************************
Reading direction RTL
*****************************************************/
:host(.rtl[icon-position=start]) gxg-icon {
  right: 0;
  left: auto;
}

:host(.rtl[icon-position=end]) gxg-icon {
  right: auto;
  left: 0;
}

/*********************************************
LARGE VERSION (html tag has 'gxg-large' class)
**********************************************/
:host(.large) label {
  font-size: var(--font-size-lg);
}
:host(.large) input {
  font-size: var(--font-size-lg);
}
:host(.large) input[type=text],
:host(.large) input[type=password] {
  padding-left: 7px;
  padding-right: 7px;
}

:host(.large.has-icon[icon-position=start]) input {
  padding-inline-start: var(--spacing-comp-05);
}
:host(.large.has-icon[icon-position=start]) input .inner-wrapper gxg-icon {
  left: 2px;
}

:host(.large[icon-position=end]) input {
  padding-inline-end: var(--spacing-comp-05);
}

:host(.large[icon-position=start]) .inner-wrapper gxg-icon {
  left: 2px;
}

:host(.large[icon-position=end]) .inner-wrapper gxg-icon {
  right: 4px;
  left: auto;
}

:host(.large) gxg-icon.clear-button {
  right: 5px !important;
  left: auto !important;
}

:host(.large[icon-position=end][clear-button]) .inner-wrapper gxg-icon {
  right: 26px;
}

:host(.large.has-icon[icon-position=start][clear-button]) input {
  padding-inline-end: 26px;
}

:host(.large[icon-position=end][clear-button]) input {
  padding-inline-end: 48px;
}